const getObject = <TValue = unknown>(key: string): TValue | undefined => {
  const storeValue = localStorage.getItem(key);
  if (storeValue === null) return undefined;

  return JSON.parse(storeValue);
};

export { getObject };
